import BaseSlideout from '../slideout';

import './infoPanel.scss';

type InfoPanelProps = {
  title: string;
  richText: string[];
  isVisible: boolean;
  onClose?: () => void;
  isLoading?: boolean;
  errorMessage?: string;
};

const InfoPanel = ({
  title,
  richText,
  isVisible,
  onClose,
  isLoading,
  errorMessage,
}: InfoPanelProps) => {
  return (
    <BaseSlideout
      title={title}
      isVisible={isVisible}
      onClose={onClose}
      isLoading={isLoading}
      errorMessage={errorMessage}
      className="info-panel"
    >
      {isLoading && (
        <>
          <div className="slideout-skeleton">
            <div className="skeleton-header" />
          </div>
          <hr className="divider" />
          <div className="scrollable-content">
            <div className="slideout-skeleton">
              <div className="skeleton-image" />
              <div className="skeleton-line short" />
              <div className="skeleton-line" />
              <div className="skeleton-line" />
            </div>
          </div>
        </>
      )}

      {!isLoading && errorMessage && (
        <p className="error-message">{errorMessage}</p>
      )}
      {!isLoading && !errorMessage && (
        <>
          <hr className="divider" />
          <div className="info-description">
            {richText.map((text, idx) => (
              <div key={idx} dangerouslySetInnerHTML={{ __html: text }} />
            ))}
          </div>
        </>
      )}
    </BaseSlideout>
  );
};

export default InfoPanel;
